export { default } from "./TimedTabs";
export * from "./TimedTabs";
export * from "./TimedTabs.model";
